import React, { Component } from "react";
import PropTypes from "prop-types";

import {
  InputMultiButton,
  SelectorGroup,
  PanelHeader,
  InputControl
} from "../../components";

import CoreDataTransformations from "../_utils/coreDataTransformations";

class CoreReportProperties extends Component {
  state = {
    report: this.props.report
  };

  componentWillReceiveProps(newProps) {
    if (this.state.report !== newProps.report) {
      this.setState({
        report: newProps.report
      });
    }
  }

  onRemoveGroup = groupType => () => {
    let newReport = Object.assign({}, this.state.report);
    delete newReport.groups[groupType];

    this.setState(
      {
        report: newReport
      },
      () => this.updateReportProps()
    );
  };

  onUpdateGroupTypes = selectedValues => {
    const newGroups = {};
    selectedValues.forEach(groupType => {
      if (!this.state.report.groups[groupType]) {
        //add new one with empty selectors
        newGroups[groupType] = {
          elements: {
            selectedValues: []
          },
          variables: {
            selectedValues: []
          }
        };
      } else {
        //copy existing values
        newGroups[groupType] = this.state.report.groups[groupType];
      }
    });

    this.setState(
      prevState => ({
        report: {
          ...prevState.report,
          groups: newGroups
        }
      }),
      () => this.updateReportProps()
    );
  };

  onUpdateInputSelector = (groupType, controlType) => newValues => {
    let newState = Object.assign({}, this.state);
    newState.report.groups[groupType][controlType].selectedValues = newValues;
    this.setState(newState, () => this.updateReportProps());
    // this.setState(
    //   prevState => ({
    //     report: {
    //       ...prevState.report,
    //       groups: {
    //         ...prevState.groups,
    //         [groupType]: {
    //           ...prevState.groups[groupType],
    //           [controlType]: {
    //             ...prevState.groups[groupType][controlType],
    //             selectedValues: newValues
    //           }
    //         }
    //       }
    //     }
    //   }),
    //   () => this.updateReportProps()
    // );
  };

  updateReportProps = () => {
    const { onUpdate } = this.props;

    onUpdate(this.state.report);
  };

  render() {
    const { options, selectedValues } = this.props;
    const { report } = this.state;

    const selectedGroups = CoreDataTransformations.getGroupTypesFromReport(
      report
    );

    return (
      <div>
        {report && (
          <div>
            <div
              style={{
                padding: "8px",
                borderBottom: "2px solid #ededed"
                //backgroundColor: "#fff"
              }}
            >
              <h2 style={{ color: "#fff" }}>
                {report
                  ? CoreDataTransformations.getReportTitle(report)
                  : "Please select a report"}
              </h2>

              <div style={{ textAlign: "right" }}>
                <InputMultiButton
                  options={options.groupTypes}
                  selectedValues={selectedGroups}
                  onChange={this.onUpdateGroupTypes}
                />
              </div>
            </div>
            <div
              style={{
                height: "80vh",
                overflowY: "auto"
                // background: "rgb(222, 222, 222)"
              }}
            >
              {selectedGroups.map(groupType => (
                <SelectorGroup
                  key={groupType}
                  heading={groupType}
                  onRemoveGroup={this.onRemoveGroup(groupType)}
                  body={
                    <div>
                      <PanelHeader
                        heading={"Elements"}
                        errorMessage={
                          (!report.groups[groupType].elements.selectedValues ||
                            report.groups[groupType].elements.selectedValues
                              .length < 1) &&
                          (report.groups[groupType].variables.selectedValues &&
                            report.groups[groupType].variables.selectedValues
                              .length > 0)
                            ? "Please select an element"
                            : ""
                        }
                      />
                      <InputControl
                        groupType={groupType}
                        controlType={"elements"}
                        selectionMode={
                          "multiple" //selectedReport.groups[groupType].elements.selectionMode
                        }
                        dataMode={selectedValues.selectedDataMode}
                        options={options[`${groupType}_objects`]}
                        selectedValues={
                          report.groups[groupType].elements.selectedValues
                        }
                        onChange={this.onUpdateInputSelector(
                          groupType,
                          "elements"
                        )}
                      />
                      <PanelHeader
                        heading={"Variables"}
                        errorMessage={
                          (!report.groups[groupType].variables.selectedValues ||
                            report.groups[groupType].variables.selectedValues
                              .length < 1) &&
                          (report.groups[groupType].elements.selectedValues &&
                            report.groups[groupType].elements.selectedValues
                              .length > 0)
                            ? "Please select a variable"
                            : ""
                        }
                      />

                      <InputControl
                        groupType={groupType}
                        controlType={"variables"}
                        selectionMode={
                          "multiple" //selectedReport.groups[groupType].variables.selectionMode
                        }
                        dataMode={selectedValues.selectedDataMode}
                        options={options[`${groupType}_variables`]}
                        selectedValues={
                          report.groups[groupType].variables.selectedValues
                        }
                        disabledValues={CoreDataTransformations.getDisabledValues(
                          options[`${groupType}_variables`],
                          selectedValues.selectedDataMode
                        )}
                        onChange={this.onUpdateInputSelector(
                          groupType,
                          "variables"
                        )}
                      />
                    </div>
                  }
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

CoreReportProperties.propTypes = {
  report: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  selectedValues: PropTypes.object.isRequired,
  onUpdate: PropTypes.func.isRequired
};

export default CoreReportProperties;



// WEBPACK FOOTER //
// ./src/views/core/core_report_properties/CoreReportProperties.jsx